// Transforms/Prettifies distance display value (in dropdowns for instance)
// Input has to be a number or a string representing distance in meters
// Output will be the input value converted to km starting from 1000 + the appropriate unit of distance
// e.g: 500 => '500 m',  1000 => '1 km', etc.

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatDistance',
    standalone: true,
})

export class FormatDistancePipe implements PipeTransform {

  transform(value: string | number): string {
    const kilo = 1000;

    if (typeof value === 'string') {
      value = parseInt(value, 10);
    }

    if (value >= kilo) {
      return (value / kilo).toFixed(value % 1000 ? 3 : 0) + ' km';
    } else {
      return Math.floor(value) + ' m';
    }
  }

}
